import i18next, { type i18n } from "i18next";
import { LANGUAGE_CODES, SOURCE_LANGUAGE } from "./languages";
import { RESOURCES } from "./resources";

export * from "./languages";
export { RESOURCES, type Messages, type TranslationKey } from "./resources";

/** Creates an initialised, independent i18next instance with all languages loaded. */
export function createI18n(language: string = SOURCE_LANGUAGE): i18n {
  const instance = i18next.createInstance();
  void instance.init({
    lng: LANGUAGE_CODES.includes(language) ? language : SOURCE_LANGUAGE,
    fallbackLng: SOURCE_LANGUAGE,
    supportedLngs: [...LANGUAGE_CODES],
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    initAsync: false,
    resources: Object.fromEntries(
      Object.entries(RESOURCES).map(([code, messages]) => [code, { translation: messages }]),
    ),
  });
  return instance;
}

/** Simple synchronous lookup without i18next, for scripts (manual generator). */
export function translate(language: string, key: string, vars: Record<string, string> = {}): string {
  const text = RESOURCES[language]?.[key] ?? RESOURCES[SOURCE_LANGUAGE]?.[key];
  if (text === undefined) throw new Error(`Missing translation key: ${key}`);
  return text.replace(/\{\{(\w+)\}\}/g, (_, name: string) => vars[name] ?? `{{${name}}}`);
}
